import { Component, ViewEncapsulation, Input } from '@angular/core';
import { ResortSummary } from '../../models/presentation.model';
import { Core, OvsComponent } from '../../shared/core/ovs.core';
import { Coordinates } from '../../shared/geo/ovs.geocoding';
import { ResortComponent } from '../../shared/resort.component';
import { fadeInAnimation } from '../../shared/animations';
import { DistanceInfo } from '../distance-info.model';
import { SearchResultEvents } from '../../instrumentation/resort-custom-events';
import { UserActivityLogger, UserActivityLoggerOptions } from '../../instrumentation/user-activity-logger.service';

@Component({
  selector: 'resort-listing-header',
  templateUrl: './resort-listing-header.component.html',
  styleUrls: ['./resort-listing-header.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ResortListingHeaderComponent extends ResortComponent {
  @Input()
  public startDate: Date;
    @Input()
    public resort: ResortSummary = new ResortSummary();
    @Input()
    public geometry: Coordinates;
    @Input()
    public distanceInfo: DistanceInfo;

    public get hasDiscount() : boolean{
        return (this.resort.startingFromPurchase - this.resort.startingFromDiscount) > 0 ;
      }

    public get savingsPercentRate(): number{
        if(this.resort.startingFromPurchase > 0 )
        {
            return Math.floor((1 - (this.resort.startingFromDiscount/this.resort.startingFromPurchase)) *100);
        }
        return 0;
    }

    public get hasEarnReward(): boolean{
        return this.resort.rewardsUpTo > 0;
      }

      public explore():void {
        UserActivityLogger.logEvent(SearchResultEvents.ExploreButtonClicked, {resortId: this.resort.id, date: this.startDate}, UserActivityLoggerOptions.AppInsightsOnly);
      }

  // constructor() { }

  // ngOnInit() {
  // }


  public get showDiscountBadge(): boolean {

      if ((this.resort.startingFromPurchase - this.resort.startingFromDiscount) >= 1) {
          if (this.resort.startingFromPurchase > 0) {
              if (Math.floor((1 - (this.resort.startingFromDiscount / this.resort.startingFromPurchase)) * 100) >= 1) {
                  return true;
              }
          }
      }
      return false;
    }
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/Ovs.Resort.UI.Web/src/app/resort-listing/resort-listing-header/resort-listing-header.component.ts